import { createContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import { useAuth } from "../../auth/components/AuthInit";

const MasterLayoutContext = createContext();

export const MasterLayout = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const [isShow, setIsShow] = useState(true);
  const value = {};

  useEffect(() => {
    const handleTokenChange = () => {
      setSwalProps({
        show: true,
        icon: "error",
        text: "Please avoid logging in with the same account\n请避免使用同一账号登入\nSila elakkan log masuk dengan  akaun yan sama",
      });
    };

    window.addEventListener("sessionLost", handleTokenChange);

    const manageNavBar = (e) => {
      setIsShow(e.detail?.value?.toString() === "true");
    };

    window.addEventListener("manageNavBar", manageNavBar);

    return () => {
      window.removeEventListener("sessionLost", handleTokenChange);
      window.removeEventListener("manageNavBar", manageNavBar);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("h-100");
    document.documentElement.classList.add("h-100");
    document.getElementById("root").classList.add("h-100");
  }, []);

  const navClass =
    "w-20 d-flex flex-column align-items-center justify-content-center bottom-nav-item";

  return (
    <>
      <SweetAlert2
        heightAuto={false}
        {...swalProps}
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
          logout();
        }}
      />
      <MasterLayoutContext.Provider value={value}>
        <div
          className="rc279-content d-flex flex-column align-items-stretch h-100 w-100"
          style={{
            backgroundImage: `url('${toAbsoluteUrl(
              "/image/homebackground.webp"
            )}')`,
          }}
        >
          <div
            className="flex-fill overflow-auto outlet-wrapper mx-auto w-100"
            style={{ maxWidth: isShow ? "1300px" : undefined }}
          >
            <Outlet />
          </div>
          {isShow && (
            <div
              className="text-white d-flex bg-dark py-1 shadow mx-auto w-100"
              style={{ maxWidth: "1300px" }}
            >
              <div
                className={`${navClass} ${
                  location.pathname === "/home" ? "active" : ""
                }`}
                onClick={() => navigate("/home")}
              >
                <img
                  className="bottom-nav-icon"
                  src={`${process.env.PUBLIC_URL}/image/icon/games.avif`}
                />
                <div>{intl.formatMessage({ id: "home" })}</div>
              </div>
              <div
                className={`${navClass} ${
                  location.pathname === "/setting/contactUs" ? "active" : ""
                }`}
                onClick={() => navigate("/setting/contactUs")}
              >
                <img
                  className="bottom-nav-icon"
                  src={`${process.env.PUBLIC_URL}/image/icon/wallet2.avif`}
                />
                <div>{intl.formatMessage({ id: "chat" })}</div>
              </div>
              <div
                className={`${navClass} ${
                  location.pathname === "/promotion" ? "active" : ""
                }`}
                onClick={() => navigate("/promotion")}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/image/icon/promotion-bottom.webp`}
                  style={{ width: "30px", height: "30px" }}
                />
                <div>{intl.formatMessage({ id: "promotion" })}</div>
              </div>
              <div
                className={`${navClass} ${
                  location.pathname === "/report" ? "active" : ""
                }`}
                onClick={() => navigate("/report")}
              >
                <img
                  className="bottom-nav-icon"
                  src={`${process.env.PUBLIC_URL}/image/icon/results.avif`}
                />
                <div>{intl.formatMessage({ id: "report" })}</div>
              </div>
              <div
                className={`${navClass} ${
                  location.pathname !== "/setting/contactUs" &&
                  location.pathname.includes("/setting")
                    ? "active"
                    : ""
                }`}
                onClick={() => navigate("/setting/profile")}
              >
                <img
                  className="bottom-nav-icon"
                  src={`${process.env.PUBLIC_URL}/image/icon/profile.avif`}
                />
                <div>{intl.formatMessage({ id: "profile" })}</div>
              </div>
            </div>
          )}
        </div>
      </MasterLayoutContext.Provider>
    </>
  );
};
